import React, { Component } from "react";
import Slider from "react-slick";
import { Experience, Technology, RelatedCourses, About } from "./FieldBlock";
import style from "./profile.scss";

class Profile extends Component {
  render() {
    const settings = {
      dots: true,
      arrows: false,
      fade: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      speed: 800,
      autoplaySpeed: 2500,
      cssEase: "ease-out",
      swipeToSlide: true,
      pauseOnHover: true,
    };
    return (
      <div className={style["profile"]}>
        <Slider {...settings}>
          <Experience />
          <Technology />
        </Slider>
        <div className={style["spacing"]} />
        <Slider {...settings}>
          <RelatedCourses />
          <About />
        </Slider>
      </div>
    );
  }
}

export default Profile;
